define('views/articlefolder/index',[],function() {
	'use strict';

});
